import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import { getDisplays } from './helpers';
import DisplayIcon from './DisplayIcon';
import Description from './Description';
import RealtimeInfo from './RealtimeInfo';
import { isCancelled } from '../../../../services/LiveDepartureService';
import { formatCarriageCountLabel } from '../../../../services/CarriageCountService';

const MovementInfo = forwardRef(({
  movement, mode, disablePredictionDisplay, carriageCount,
}, ref) => {
  const movementDisplays = getDisplays(movement, mode, disablePredictionDisplay);

  const { ariaLabel, arriving, departed, dueTimeDisplay, stopsAway } = movementDisplays;
  const isLive = (arriving || departed || !isNil(dueTimeDisplay ?? stopsAway)) && !disablePredictionDisplay;

  const cancelled = isCancelled(movement.arrivalStatus);
  const cancelledClassName = cancelled ? 'movement-info-cancelled' : '';
  const carriageLabel = mode === 'TRAIN' && !cancelled ? formatCarriageCountLabel(carriageCount) : null;
  const rowAriaLabel = carriageLabel ? `${ariaLabel}, ${carriageLabel}` : ariaLabel;

  return (
    <li
      ref={ref}
      aria-label={rowAriaLabel}
      className={`movement-info-container ${departed ? 'movement-info-container-departed' : ''}`}
    >
      <div className={`movement-info ${cancelledClassName}`}>
        <div className="movement-info-left-container">
          <DisplayIcon mode={mode} isLive={isLive} cancelled={cancelled} />
          <Description cancelled={cancelled} {...movementDisplays} carriageCount={carriageLabel ? carriageCount : null} />
        </div>
        <RealtimeInfo {...movementDisplays} />
      </div>
    </li>
  );
});
MovementInfo.propTypes = {
  movement: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  disablePredictionDisplay: PropTypes.bool,
  carriageCount: PropTypes.number,
};
MovementInfo.defaultProps = {
  disablePredictionDisplay: false,
  carriageCount: null,
};

export default MovementInfo;